import { useEffect } from 'react';

type RetFun = () => void;

export default function useEffectOnce(effect: () => RetFun | void) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect, []);
}
